import React from 'react'
import { string, bool, node } from 'prop-types'

import classNames from 'src/common/helpers/class-names'

const PromoText = ({ show, children, tag }) => {
  if (!show) return null
  const blk = 'co-product'
  const hyperlinkMod = tag === 'link' ? ['hyperlink'] : []

  return (
    <span
      className={classNames({ blk, elt: 'promo-text', mods: hyperlinkMod })}
    >
      {children}
    </span>
  )
}

PromoText.propTypes = {
  show: bool,
  children: node,
  tag: string,
}

PromoText.defaultProps = {
  show: true,
  children: null,
  tag: '',
}

export default PromoText



// WEBPACK FOOTER //
// ./shared/interim/product/promo/promoText.js